<template>
  <div>
    <div class="speakInput">
      <div class="title">
        <span>评论</span>
      </div>
      <div class="speakBox">
        <textarea v-model="textContent" placeholder="欢迎留言评论" class="speakMsg" maxlength="200" />
      </div>
      <el-button :autofocus="autofocus" @click="Gofabu">
        发布
      </el-button>
    </div>
    <div class="title">
      <span>热门评论</span>
    </div>
    <div class="hotSpeak">
      <div v-for="(item,index) in hotSpeakData" v-show="hotSpeakData.length>=0" :key="index" :class="index===hotSpeakData.length-1?'lastspeakBox':'speakBox'">
        <div class="userIMG">
          <img v-if="item.USER_PHOTO" :src="item.USER_PHOTO" alt="">
          <img v-else :src="userDefault" alt="">
        </div>
        <div class="createName">
          <span class="names">{{ item.USER_NAME }} </span>
          <p class="createSource">
            {{ item.SPEAK_SOURCE }}
          </p>
          <div class="content">
            {{ item.SPEAK_CONTENT }}
          </div>
          <div class="footbox">
            <span class="times">{{ item.CREATE_DATE|changeSpeak }}</span>
            <p class="rightmsg">
              <span style="display: none"><svg-icon icon-class="zan" />赞{{ item.PRAISE_SIZE|changenum }}</span>
              <span @click="huifu(index)"><svg-icon icon-class="huifu" class="hui" />回复</span>
              <span v-show="item.SPEAK_SIZE" class="huifuNumber">{{ item.SPEAK_SIZE|changenum }}条回复</span>
            </p>
          </div>
        </div>
        <div v-show="!item.fold" class="huifuInput">
          <div class="sanjiao" />
          <div class="speakBox">
            <textarea v-model="textContent_child" :placeholder="['回复@'+item.USER_NAME+':']" class="speakMsg2" maxlength="200" />
          </div>
          <el-button @click="fabuhuifu(item.SPEAK_ID,index)">
            发布
          </el-button>
          <span class="quxiao" @click="quxiao1(index)">取消回复</span>
        </div>
      </div>
      <div v-show="hotSpeakData<=0" class="nospeak">
        当前内容暂无热评
      </div>
    </div>
    <div class="title">
      <span>最新评论</span>
    </div>
    <div class="hotSpeak">
      <div v-for="(item,index) in newSpeakData" v-show="newSpeakData.length>=0" :key="index" class="speakBox">
        <div class="userIMG">
          <img v-if="item.USER_PHOTO" :src="item.USER_PHOTO" alt="">
          <img v-else :src="userDefault" alt="">
        </div>
        <div class="createName">
          <span class="names">{{ item.USER_NAME }} </span>
          <p class="createSource">
            {{ item.SPEAK_SOURCE }}
          </p>
          <div class="content">
            {{ item.SPEAK_CONTENT }}
          </div>
          <div class="footbox">
            <span class="times">{{ item.CREATE_DATE|changeSpeak }}</span>
            <p class="rightmsg">
              <span style="display:none;"><svg-icon icon-class="zan" />赞{{ item.PRAISE_SIZE|changenum }}</span>
              <span @click="huifu(index,'isnew')"><svg-icon icon-class="huifu" class="hui" />回复</span>
              <span v-show="item.readFold" class="huifuNumber" @click="readhuifu(index)">收起回复<svg-icon icon-class="top" /></span>
              <span v-show="!item.readFold" class="huifuNumber" @click="readhuifu(index)">查看回复<svg-icon icon-class="bottom" /></span>
            </p>
          </div>
        </div>
        <div v-show="!item.fold" class="huifuInput">
          <div class="sanjiao sanjiao2" />
          <div class="speakBox">
            <textarea v-model="textContent_child_new" :placeholder="['回复@'+item.USER_NAME+':']" class="speakMsg2" maxlength="200" />
          </div>
          <el-button @click="fabuhuifu(item.SPEAK_ID,index,'isnew')">
            发布
          </el-button>
          <span class="quxiao" @click="quxiao1(index,'isnew')">取消回复</span>
        </div>
        <div v-show="item.readFold" class="readList">
          <hotChild :parent-i-d="item.SPEAK_ID" :content="contentId" @showlogins="handelshow" />
        </div>
      </div>
      <div v-show="newSpeakData<=0" class="nospeak">
        当前内容暂无最新评论
      </div>
    </div>
    <!--<ul class="fenye">-->
    <!--<li v-for="item in allPage" :class="nowPage==item?'isnow':''" @click="gopage(item)">-->
    <!--{{ item }}-->
    <!--</li>-->
    <!--<li class="lastpage" @click="nextpage">-->
    <!--下一页-->
    <!--</li>-->
    <!--</ul>-->
    <el-pagination
      v-if="newSpeakData.length>0"
      background
      layout="prev, pager, next"
      :total="count"
      :page-size="5"
      :current-page="nowPage"
      @current-change="gopage"
    />
  </div>
</template>

<script>
import { addSpeak, hotSpeak } from '@/api/api.js'
import Vue from 'vue'
import hotChild from '@/components/Detail_speak/newSpeak/index.vue'
import { ssoUserLogin } from '@/api/api.js'

export default {
  inject: ['reload'],
  name: 'Speak',
  components: { hotChild },
  props: ['contentId'],
  data() {
    return {
      userDefault: require('@/static/usuerDefault.png'),
      autofocus: false,
      textContent: '',
      hotSpeakData: [],
      textContent_child: '',
      newSpeakData: [],
      textContent_child_new: '',
      nowPage: 1,
      allPage: 1,
      count: ''
    }
  },
  created() {
    var obj = {}
    obj.contentId = this.contentId
    obj.speakIsRecommend = '1'
    obj.index = '1'
    obj.size = '5'
    obj.speakParentId = '0'
    hotSpeak(obj).then(res => {
      // console.log(res.data)
      this.hotSpeakData = res.data.listMapData
      for (let i = 0; i < this.hotSpeakData.length; i++) {
        var item = this.hotSpeakData[i]
        item.fold = true
        item.readFold = true
      }
    })
  },
  beforeMount() {
    var obj = {}
    obj.contentId = this.contentId
    obj.speakIsRecommend = '0'
    obj.index = '1'
    obj.size = '5'
    obj.speakParentId = '0'
    hotSpeak(obj).then(res => {
      this.newSpeakData = res.data.listMapData
      this.count = res.data.count
      this.allPage = Math.ceil(res.data.count / 5) * 1
      for (let i = 0; i < this.newSpeakData.length; i++) {
        var item = this.newSpeakData[i]
        item.fold = true
        item.readFold = true
      }
    })
  },
  mounted() {

  },
  methods: {
    // /新增回复对栏目
    Gofabu: function() {
      var obj = {}
      obj.contentId = this.contentId
      obj.speakContent = this.textContent
      obj.speakType = 1
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
          if (obj.speakContent) {
            addSpeak(obj).then(res => {
              if (res.data) {
                this.$message({
                  showClose: true,
                  message: '恭喜您，评论成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: '评论失败请稍后再试',
                  type: 'warning'
                })
              }
              this.reload()
            })
          } else {
            this.$message({
              showClose: true,
              message: '请输入评论内容',
              type: 'warning'
            })
          }
        } else {
          this.$emit('showlogin')
        }
      })
    },
    // /切换回复显示1
    huifu: function(index, isnew) {
      this.textContent_child = ''
      if (isnew) {
        for (let i = 0; i < this.newSpeakData.length; i++) {
          this.newSpeakData[i].fold = true
        }
        this.newSpeakData[index].fold = false
        Vue.set(this.newSpeakData, index, this.newSpeakData[index])
      } else {
        for (let i = 0; i < this.hotSpeakData.length; i++) {
          this.hotSpeakData[i].fold = true
        }
        this.hotSpeakData[index].fold = false
        Vue.set(this.hotSpeakData, index, this.hotSpeakData[index])
      }
    },
    // //取消回复
    quxiao1: function(index, isnew) {
      if (isnew) {
        this.textContent_child = ''
        this.newSpeakData[index].fold = !this.newSpeakData[index].fold
        Vue.set(this.newSpeakData, index, this.newSpeakData[index])
      } else {
        this.textContent_child = ''
        this.hotSpeakData[index].fold = !this.hotSpeakData[index].fold
        Vue.set(this.hotSpeakData, index, this.hotSpeakData[index])
      }
    },
    // //查看回复
    // /取消子集回复
    readhuifu: function(index) {
      // /查看回复
      this.newSpeakData[index].readFold = !this.newSpeakData[index].readFold
      Vue.set(this.newSpeakData, index, this.newSpeakData[index])
    },
    // ///// /切换回复显示2
    fabuhuifu: function(id, index, isnew) {
      var obj = {}
      obj.contentId = this.contentId
      obj.speakParentId = id
      if (isnew) {
        for (let i = 0; i < this.newSpeakData.length; i++) {
          this.newSpeakData[i].fold = true
        }
        Vue.set(this.newSpeakData, index, this.newSpeakData[index])
        obj.speakContent = this.textContent_child_new
      } else {
        for (let i = 0; i < this.hotSpeakData.length; i++) {
          this.hotSpeakData[i].fold = true
        }
        Vue.set(this.hotSpeakData, index, this.hotSpeakData[index])
        obj.speakContent = this.textContent_child
      }
      ssoUserLogin().then(res => {
        if (res.data.userId) {
          this.setloca('userid', res.data.userId, 7200)
          localStorage.removeItem('unionid')
          if (obj.speakContent) {
            obj.speakType = 1
            addSpeak(obj).then(res => {
              if (res.data) {
                this.$message({
                  showClose: true,
                  message: '恭喜您，评论成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: '评论失败请稍后再试',
                  type: 'warning'
                })
              }
              this.reload()
            })
          } else {
            this.$message({
              showClose: true,
              message: '请输入评论内容',
              type: 'warning'
            })
          }
        } else {
          this.$emit('showlogin')
        }
      })
    },
    gopage: function(index) {
      var obj = {}
      obj.contentId = this.contentId
      obj.speakIsRecommend = '0'
      obj.index = index + ''
      obj.size = '5'
      obj.speakParentId = '0'
      hotSpeak(obj).then(res => {
        this.newSpeakData = res.data.listMapData
        for (let i = 0; i < this.newSpeakData.length; i++) {
          var item = this.newSpeakData[i]
          item.fold = true
          item.readFold = true
        }
      })
      this.nowPage = index
    },
    nextpage: function() {
      if (this.nowPage !== this.allPage) {
        var obj = {}
        obj.contentId = this.contentId
        obj.speakIsRecommend = '0'
        obj.index = this.nowPage * 1 + 1
        obj.size = '5'
        obj.speakParentId = '0'
        hotSpeak(obj).then(res => {
          this.newSpeakData = res.data.listMapData
          this.allPage = res.data.page
          this.count = res.data.count
          for (let i = 0; i < this.newSpeakData.length; i++) {
            var item = this.newSpeakData[i]
            item.fold = true
            item.readFold = true
          }
        })
        this.nowPage = this.nowPage * 1 + 1
      }
    },
    handelshow() {
      this.$emit('showlogin')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .speakInput{
        margin: 20px 0;
        overflow: hidden;
      .speakBox{
        margin-left: 20px;
        margin-top: 20px;
        padding-right: 15px;
        .speakMsg{
          height: 115px;
          width: 100%;
          padding: 10px 15px;
          box-sizing: border-box;
          outline: none;
          resize:none;
        }
      }

        .el-button{
            border: 2px solid #ed4040;
            float: right;
            margin-right: 20px;
            margin-top: 10px;
            color: #ed4040;
            width: 86px;
            display: inline-block;
            line-height: 10px;
            &:hover{
                background-color: #ed4040;
                color: #ffffff;
            }
        }
    }
    .title{
        padding-bottom: 5px;
        border-bottom: 2px solid #e5e5e5;
        span{
            display: inline-block;
            padding-left: 7px;
            height: 20px;
            border-left: 2px solid #ed4040;
            font-size: 16px;
            line-height: 20px;
        }
    }
    .hotSpeak{
        margin: 20px 20px;
      overflow: hidden;
      .nospeak{
        height: 50px;
        font-size: 20px;
        text-align: center;
        color: #a19d9e;
        line-height: 50px;
      }
        .lastspeakBox{
            position:relative;
            margin-top: 20px;
            overflow: hidden;
            padding-bottom: 20px;
        }
        .speakBox{
            position:relative;
            margin-top: 20px;
            overflow: hidden;
            padding-bottom: 20px;
            border-bottom: 1px solid #e5e5e5;
        }
        .huifuInput{
            position: relative;
            overflow: hidden;
            .sanjiao{
                display: inline-block;
                position: absolute;
                bottom: 178px;
                width: 18px;
                height:18px;
                left: 705px;
                background-color: #fff;
               border-left: 1px  solid #e5e5e5;
                border-top: 1px  solid #e5e5e5;
                -webkit-transform:rotate(45deg);
              z-index: 9;
            }
            .sanjiao2{
                left: 700px;
            }
            .quxiao{
                display: inline-block;
                float: right;
                margin-top: 12px;
                color: #b2b2b2;
                width: 86px;
                height: 35px;
                line-height: 35px;
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                 }
            }
            .el-button{
                border: 1px solid #ed4040;
                float: right;
                margin-top: 10px;
                margin-right: 20px;
                color: #ed4040;
                width: 86px;
                display: inline-block;
                line-height: 10px;
                &:hover{
                    background-color: #ed4040;
                    color: #ffffff;
                }
            }
        }
        .huifuNumber{
            cursor: pointer;
            &:hover{
                color: #ed4040;
            }
        }
        .readList{
            border-left: 2px solid #e5e5e5;
            display: block;
            padding-left: 10px;
            margin-left: 28px;
            margin-top: 20px;
            .createName{
                width: 750px;
            }
            .loadmore{
                display: inline-block;
                color: #b2b2b2;
                cursor: pointer;
                margin-left: 370px;
                &:hover{
                    color: #ed4040;
                }
            }
        }
    }
    .hotSpeak{
        .userIMG{
            width: 38px;
            height: 38px;
            border-radius: 50%;
            background-color: red;
            float: left;
          overflow: hidden;
          img{
            width: 38px;
            height: 38px;
          }
        }
        .createName{
            overflow: hidden;
            line-height: 25px;
            margin-left: 47px;
            .names{
                font-size: 15px;
                cursor: pointer;
                color: #456eb3;
                margin-left: 10px;
            }
            p{
                display: inline-block;
                font-size: 12px;
                color: #b2b2b2;
                margin-left: 5px;
            }
            .content{
                color: #656565;
                font-size: 14px;
                margin-left: 10px;
            }
            .footbox{
                margin-top: 10px;
                margin-left: 10px;
                color: #b2b2b2;
                .times{
                    font-size: 13px;
                    display: inline-block;
                }
                .rightmsg{
                    float: right;
                    display: inline-block;
                    span{
                        margin-left: 5px;
                        font-size: 14px;
                      cursor: pointer;
                        .hui{
                            height: 25px;
                            vertical-align: bottom;
                            cursor: pointer;
                            &:hover{
                                color: #ed4040;
                            }
                        }
                        svg{
                            font-size: 19px;
                            margin-left: 5px;
                        }
                    }
                }
            }
        }
      .speakBox{
        margin-top: 20px;
      }
        .speakMsg2{
            height: 115px;
            outline: none;
            width: 100%;
          padding: 10px 15px;
          box-sizing: border-box;
            border-color: #e5e5e5;
            resize:none;
        }
        .speakMsg3{
            height: 115px;
            outline: none;
            width: 100%;
          padding: 10px 15px;
          box-sizing: border-box;
            border-color: #e5e5e5;
            resize:none;
        }

    }
    .el-pagination{
        margin: 20px auto;
        text-align: center;
        color:#b2b2b2;
    }

</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .title {
      margin: 0 20px;
    }
  }
</style>
